/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_DressInputs */

const en_val_dress = /** @type {(inputs: Val_DressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dress`)
};

const es_val_dress = /** @type {(inputs: Val_DressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vestido`)
};

const fr_val_dress = /** @type {(inputs: Val_DressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Robe`)
};

const de_val_dress = /** @type {(inputs: Val_DressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kleid`)
};

const ja_val_dress = /** @type {(inputs: Val_DressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ワンピース・ドレス`)
};

const zh_val_dress = /** @type {(inputs: Val_DressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`连衣裙`)
};

const ar_val_dress = /** @type {(inputs: Val_DressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فستان`)
};

const id_val_dress = /** @type {(inputs: Val_DressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gaun`)
};

const it_val_dress = /** @type {(inputs: Val_DressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vestito`)
};

const ru_val_dress = /** @type {(inputs: Val_DressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Платье`)
};

const pt_val_dress = /** @type {(inputs: Val_DressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vestido`)
};

const ko_val_dress = /** @type {(inputs: Val_DressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`원피스/드레스`)
};

/**
* | output |
* | --- |
* | "Dress" |
*
* @param {Val_DressInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_dress = /** @type {((inputs?: Val_DressInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_DressInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_dress(inputs)
	if (locale === "es") return es_val_dress(inputs)
	if (locale === "fr") return fr_val_dress(inputs)
	if (locale === "de") return de_val_dress(inputs)
	if (locale === "ja") return ja_val_dress(inputs)
	if (locale === "zh") return zh_val_dress(inputs)
	if (locale === "ar") return ar_val_dress(inputs)
	if (locale === "id") return id_val_dress(inputs)
	if (locale === "it") return it_val_dress(inputs)
	if (locale === "ru") return ru_val_dress(inputs)
	if (locale === "pt") return pt_val_dress(inputs)
	return ko_val_dress(inputs)
});